// extracted by mini-css-extract-plugin
export default {"container":"N--z","productName":"O--z","price":"P--z","dimensions":"Q--z"};